<template>
  <div class="layout">
    <div v-if="isTrialUser" class="trial-bar">
      <p class="text-sm text-primary-white text-center">
        Enjoy the live experience of this real device with a 2-minute free
        trial.
      </p>
    </div>
    <LaunchDeviceHeader :time="secondsToTime(time)" />
    <div class="content">
      <slot />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import LaunchDeviceHeader from "@/components/LaunchDeviceHeader";
const trialUserTimeBySecond = 2 * 60;
const firstControlTimeBySecond = 15 * 60;
const secondControlTimeBySecond = 30 * 60;
const lastControlTimeBySecond = 45 * 60;
export default {
  name: "LaunchDeviceLayout",
  components: {
    LaunchDeviceHeader,
  },
  computed: {
    ...mapGetters(["connectionStatus", "joinedUser", "isTrialUser", "session"]),
  },
  data() {
    return {
      time: 0,
      interval: null,
    };
  },
  watch: {
    connectionStatus: {
      handler(val) {
        if (val === 1) {
          this.startTimer();
        }
      },
    },
    time: {
      handler(val) {
        if (this.isTrialUser) {
          this.trialControl(val);
        }
        this.firstControl(val);
        this.secondControl(val);
        this.lastControl(val);
      },
    },
  },
  methods: {
    ...mapActions(["destroySession", "emitConfirmData"]),
    startTimer() {
      this.interval = setInterval(() => {
        this.time++;
      }, 1000);
    },
    destroy() {
      this.$socket.emit("sessionEnd", this.session.room);
    },
    secondsToTime(e) {
      const m = Math.floor((e % 3600) / 60)
          .toString()
          .padStart(2, "0"),
        s = Math.floor(e % 60)
          .toString()
          .padStart(2, "0");

      return m + ":" + s;
    },
    trialControl(time) {
      if (time === trialUserTimeBySecond) {
        clearInterval(this.interval);
        this.emitConfirmData({
          header: this.$t("confirm.time_expired.header"),
          text: this.$t("confirm.time_expired.text_2min"),
          showClose: false,
          actions: {
            confirm: this.$t("button.popup.time_expired.confirm"),
            cancel: this.$t("button.popup.time_expired.cancel"),
          },
          callback: (isConfirm) => {
            if (isConfirm) {
              this.destroySession();
              this.$router.push({
                name: "Pricing",
              });
            } else {
              this.destroy();
            }
          },
        });
        setTimeout(() => {
          this.destroy();
        }, 15000);
      }
    },
    firstControl(time) {
      if (time === firstControlTimeBySecond) {
        clearInterval(this.interval);
        this.emitConfirmData({
          header: this.$t("confirm.time_expired.header"),
          text: this.$t("confirm.time_expired.text_15min"),
          actions: {
            confirm: this.$t("button.general.continue"),
            cancel: this.$t("button.general.cancel"),
          },
          callback: (confirm) => {
            if (confirm) {
              this.startTimer();
            } else {
              this.destroy();
            }
          },
        });
      }
    },
    secondControl(time) {
      if (time === secondControlTimeBySecond) {
        clearInterval(this.interval);
        this.emitConfirmData({
          header: this.$t("confirm.time_expired.header"),
          text: this.$t("confirm.time_expired.text_30min"),
          actions: {
            confirm: this.$t("button.general.continue"),
            cancel: this.$t("button.general.cancel"),
          },
          callback: (confirm) => {
            if (confirm) {
              this.startTimer();
            } else {
              this.destroy();
            }
          },
        });
      }
    },
    lastControl(time) {
      if (time === lastControlTimeBySecond) {
        clearInterval(this.interval);
        this.emitConfirmData({
          header: this.$t("confirm.time_expired.header"),
          text: this.$t("confirm.time_expired.text_max"),
          actions: {
            confirm: this.$t("button.general.continue"),
            cancel: this.$t("button.general.cancel"),
          },
          callback: (confirm) => {
            if (confirm) {
              this.destroy();
            }
          },
        });
        setTimeout(() => {
          this.destroy();
        }, 10000);
      }
    },
    // get date difference between two dates return days
    getDateDiff(endDate) {
      const start = new Date();
      const end = new Date(endDate);
      const diff = end.getTime() - start.getTime();
      const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
      return days;
    },
  },
};
</script>

<style lang="css">
.content {
  @apply flex;
}
.trial-bar {
  @apply h-[32px] bg-alerts-success w-full flex items-center justify-center;
}
</style>
